export default "__VITE_ASSET__CeakOy3W__"